export class BaseEntity {
    id: number;
}


// WEBPACK FOOTER //
// ./~/@abosol/masterdata/src/base/base.entity.ts